import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import "./App.css";
import api from './api';

const theme = createTheme();

function Login({ setIsAuthenticated, setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/api/login", { email, password });

      localStorage.setItem("user", JSON.stringify(res.data));
      setUser(res.data); // ← これ追加
      setIsAuthenticated(true);

      const { mypage_url } = res.data;
      window.history.replaceState({}, document.title, "/");
      navigate(mypage_url);
    } catch (err) {
      console.error(err);
      setErrorMessage("メールアドレスかパスワードが違います");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .p-t-24-ex {padding-top: 0%;}
        }
        @media only screen and (min-width: 561px) {
        .p-t-24-ex {padding-top: 24%;}
        }
        `}
       </style>
      <Container className='p-t-24-ex'>
        <CssBaseline />
        <Box sx={{ margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1, width: '80%' }}>
            <div>
              <p className='m-b-0'>メールアドレス<span className='required-srt'>*</span></p>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mt: 0, backgroundColor: '#FFFFFF' }}
              />
            </div>
            <div>
              <p className='m-b-0'>パスワード<span className='required-srt'>*</span></p>
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ mt: 0, backgroundColor: '#FFFFFF' }}
              />
            </div>
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, py: 2 }} className='login-button'>
              ログイン
            </Button>
            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default Login;
